<s-polaris-choice-list
  variant="block"
  [choices]="choices"
  (choiceSelected)="onChoiceSelected($event)"></s-polaris-choice-list>
